// Krediler sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.loans';

export const loansGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Krediler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bankalardan çektiğiniz kredileri, taksit planlarını ve kalan borcunuzu bu sayfadan izlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve düğmeler'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve durum'),
    table: t(`${G}.regions.table`, 'Kredi listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kredi ekleyin'),
      text: t(`${G}.s1.text`, '"Kredi Ekle" düğmesi kredi sihirbazını açar: anapara, toplam geri ödeme, kesintiler, taksit planı ve net tutarın nereye aktarılacağı sırayla girilir. "Kredi Ödemeleri" düğmesi yapılmış tüm taksit ödemelerinin listesine götürür.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Kartlar yalnız aktif kredileri özetler. Farklı para birimindeki krediler ayrı ayrı toplanır (ör. "12.000,00 ₺ + 500,00 $").'),
      tips: [
        t(`${G}.s2.tip1`, 'Toplam Kalan Borç: aktif kredilerin henüz ödenmemiş taksitlerinin toplamı.'),
        t(`${G}.s2.tip2`, 'Bu Ay Ödenecek: vadesi bu ay içinde olan ödenmemiş taksitler.'),
        t(`${G}.s2.tip3`, 'Vadesi Geçmiş Toplam: vadesi geçtiği halde ödenmemiş taksitler. Böyle taksit varsa kartların altında kırmızı bir uyarı da çıkar.'),
        t(`${G}.s2.tip4`, 'Aktif Kredi Sayısı: kapanmamış kredi adedi.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Krediyi bulun'),
      text: t(`${G}.s3.text`, 'Arama kutusuna kredi adı, kredi numarası veya banka adı yazın. Durum filtresiyle Aktif ya da Kapandı kredileri listeleyin. "Yenile" listeyi ve kartları yeniden yükler.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Listeyi okuyun'),
      text: t(`${G}.s4.text`, 'Her satırda anapara, toplam geri ödeme, ödenen tutar ve ödenen taksit sayısı (ör. 3/12 taksit), kalan tutar ve sonraki vade görünür. Sonraki vade geçmişse kırmızı etikette kaç gün geciktiği yazar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tüm taksitler ödenince kredi kendiliğinden "Kapandı" durumuna geçer.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Taksit ödeyin, düzenleyin veya silin'),
      text: t(`${G}.s5.text`, 'Satıra tıklayın ya da ⋮ menüsünden "Detay / Taksitler"i açın; taksitler burada listelenir ve her taksidi "Öde" ile ödersiniz. "Düzenle" yalnız kredi adını, sözleşme numarasını ve notları değiştirir.'),
      tips: [
        t(`${G}.s5.tip1`, '"Sil": ödenmiş taksiti olan krediler silinemez.'),
        t(`${G}.s5.tip2`, 'Kredi silindiğinde, eklerken banka veya kasaya aktarılan net tutar hareketi geri alınmaz; gerekiyorsa o hareketi ayrıca düzeltin.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına satır sayısını seçin. Başlıktaki (i) düğmesi bu rehberi yeniden açar.'),
    },
  ],
});
